import React from "react";

function VOBTAnalysis({ chart_data }) {
    let data = [];
    chart_data?.forEach((item) => {
      data.push({
        year: item.financial_year,
        vobt: `₹ ${(Number(item.vobt) / 10000000).toFixed(2)} Cr`,
        tot_search: item.closedAssignments,
        avg_vobt: `₹ ${(Number(item.averageVobt) / 10000000).toFixed(2)} Cr`,
        avg_fee: item.averageFee,
        arpa: `₹ ${(Number(item.arpa) / 100000).toFixed(2)} L`,
      });
    });

  return (
    <>
      <style>
        {`
            .table thead tr th {
                white-space: normal !important;
                word-wrap: break-word;
                padding: 6px 8px;
            }
            
            .table tbody tr td {
            color : #202c4b;
            }
        `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Year</th>
              <th>VOBT/Total Comp</th>
              <th>Non-Board Searches</th>
              <th>Avg VOBT</th>
              <th>Avg Fee</th>
              <th>ARPA</th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 &&
              data?.map((item, index) => {
                return (
                  <tr>
                    <td>{item?.year}</td>
                    <td>{item?.vobt}</td>
                    <td>{`${item?.tot_search}`}</td>
                    <td>{item?.avg_vobt}</td>
                    <td>{`${item?.avg_fee}`}</td>
                    <td>{item?.arpa}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default VOBTAnalysis;